import { render } from "./DocumentUpload.vue?vue&type=template&id=d345fa42&scoped=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&lang=js"

import "./DocumentUpload.vue?vue&type=style&index=0&id=d345fa42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d345fa42"]])

export default __exports__